import { render } from "./pswp.vue?vue&type=template&id=2ce73b30"
import script from "./pswp.vue?vue&type=script&lang=js"
export * from "./pswp.vue?vue&type=script&lang=js"

import "./pswp.vue?vue&type=style&index=0&id=2ce73b30&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/pswp.vue'],['render',render],['__file',"pswp.vue"]])

export default __exports__